<section class="w-100 bg-white d-flex justify-content-center pt-4">
  <div class="w-80 d-flex flex-column align-items-center gap-5 mb-5">
    <h2 class="m-0 fs-3-text fw-semibold text-center h2-text">
      Pourquoi choisir la base de données Perval ?
    </h2>
    <div class="w-75 fs-5-text text-center">
      <p class="m-0">
        La base de données notariale Perval est une ressource exclusive
        exploitée par ADNOV.
      </p>
      <p>
        Elle regroupe l'ensemble des actes de vente de biens immobiliers
        effectués par les notaires
      </p>
    </div>

    <div class="row w-75">
      <div
        class="col-12 col-md-6 col-lg-3 d-flex flex-column align-items-center gap-3"
      >
        <img
          src="assets/perval-icons/references.svg"
          height="60px"
          alt="chiffres clés"
        />
        <p class="text-primary-landing text-center fs-5-text lh-sm">
          Plus de <br /><span class="fs-2-text fw-bold">25 millions</span><br />
          de références en base
        </p>
      </div>
      <div
        class="col-12 col-md-6 col-lg-3 d-flex flex-column align-items-center gap-3"
      >
        <img
          src="assets/perval-icons/time.svg"
          alt="chiffres clés"
          height="60px"
        />
        <p class="text-primary-landing text-center fs-5-text lh-sm">
          Moins de <br /><span class="fs-2-text fw-bold">6 semaines</span><br />
          pour la mise en ligne des références
        </p>
      </div>
      <div
        class="col-12 col-md-6 col-lg-3 d-flex flex-column align-items-center gap-3"
      >
        <img
          src="assets/perval-icons/client.svg"
          alt="chiffres clés"
          height="60px"
        />
        <p class="text-primary-landing text-center fs-5-text lh-sm">
          Plus de <br /><span class="fs-2-text fw-bold"
            >2 500 clients actifs</span
          ><br />
          par an
        </p>
      </div>
      <div
        class="col-12 col-md-6 col-lg-3 d-flex flex-column align-items-center gap-3"
      >
        <img
          src="assets/perval-icons/documents.svg"
          alt="chiffres clés"
          height="60px"
        />
        <p class="text-primary-landing text-center fs-5-text lh-sm">
          Plus de <br /><span class="fs-2-text fw-bold">70 000 listes</span
          ><br />de références achetées par an
        </p>
      </div>
    </div>
  </div>
</section>
